"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTemplate = void 0;
const TemplateUtils_1 = require("./TemplateUtils");
class FieldTemplate {
    static resolve(f, prefix = 0) {
        let argsString = '';
        if (f.args && f.args.length) {
            argsString = `(\n${f.args
                .map((a) => TemplateUtils_1.TemplateUtils.resolverForConnection(a, prefix + 1))
                .map((a) => `${a}`)
                .join('\n')}\n\t)`;
        }
        return `${TemplateUtils_1.TemplateUtils.descriptionResolver(f.description, prefix)}${'\t'.repeat(prefix)}${f.name}${argsString}: ${TemplateUtils_1.TemplateUtils.resolveType(f)}${TemplateUtils_1.TemplateUtils.resolveDirectives(f.directives)}`;
    }
}
exports.FieldTemplate = FieldTemplate;
